<template>
  <el-dialog title="Editar Conta Bancária" :visible.sync="visibility" :before-close="fechar" :modal-append-to-body="false" width="40%">
    <el-form size="small" label-position="top">
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item label="Status">
              <el-select v-model="conta.status"
                value-key="data"
                placeholder=""
                filterable
                default-first-option
                style="width: 100%">
                <el-option
                  v-for="item in statusConta"
                  :key="item.data"
                  :label="item.label"
                  :value="item.data">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="9">
            <el-form-item label="Tipo">
              <el-select v-model="conta.tipo"
                value-key="data"
                placeholder=""
                filterable
                default-first-option
                style="width: 100%">
                <el-option
                  v-for="item in tipos"
                  :key="item.data"
                  :label="item.label"
                  :value="item.data">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="9">
            <el-form-item label="Banco">
              <el-select v-model="conta.banco"
                value-key="data"
                placeholder=""
                filterable
                default-first-option
                style="width: 100%">
                <el-option
                  v-for="item in bancos"
                  :key="item.data"
                  :label="item.label"
                  :value="item.data">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
          
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="Titular">
              <el-input v-model="conta.titular"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item label="Agência">
              <el-input v-model="conta.agencia" ></el-input> 
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="Díg.">
              <el-input v-model="conta.digitoAgencia" ></el-input> 
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Conta">
              <el-input v-model="conta.conta"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="Díg.">
              <el-input v-model="conta.digitoConta" ></el-input> 
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="Operação">
              <el-input v-model="conta.operacao"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer">
        <el-button @click="gravar" size="small" type="primary">Confirmar</el-button>
      </span>
  </el-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { BANCOS, STATUS_CONTA, TIPO_CONTA } from '../../util/constantes.js';

export default {
  props: {
    conta: Object,
    visibility: Boolean
  },
  computed: {
    ...mapState('clientesStore', {
      cliente(state) { return state.clienteSelecionado }
    }),
    bancos() { 
      return BANCOS;
    },
    tipos() { 
      return TIPO_CONTA;
    },
    statusConta() { 
      return STATUS_CONTA;
    }
  },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
  ...mapActions('clientesStore', [
      'gravarConta'
    ]),
    gravar() {
      this.conta.cliente = { id: this.cliente.id };
      this.showLoading();

      this.gravarConta(this.conta)
      .then((response) => {
        this.hideLoading();

        switch(response.status) {
          case "SUCESSO":
            this.$message.success(response.mensagem);
            this.fechar();
            break;
          case "FALHA":
            this.$message.warning(response.mensagem);
            break;
          case "ERRO":
            this.$message.error(response.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();
      });
    },
    fechar() {
      this.$emit('close');
    }
  }
}
</script>
